import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {ToastContainer, ToastStore} from 'react-toasts';
import MetaTags from 'react-meta-tags';

import ProfileStyles from './Profile.css';

import utilities from './components/Utilities';
let Utilities = new utilities();

export default class Profile extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            user: {},
            orders: [],
            isAdmin: false
        }

    }

    componentDidMount() {
        this.getUser();
        document.title = window.globalVars.pageTitleBefore + "Profile" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    getUser = () => {

        let id = window.location.href;
        let user;
        id = id.substr(id.lastIndexOf('/') + 1);

        let orderAPIUrl = "/api/order/summary/"

        setTimeout(function() {

            if (id === "profile") {
                user =  JSON.parse(localStorage.getItem("user"));
                if (Utilities.isENU(user)) {
                    this.props.history.push("/login");
                    return;
                }
                id = user._id;
                this.setState({
                    isAdmin: false
                })
            } else {
                orderAPIUrl = "/api/order/user-summary/" + id;
                this.setState({
                    isAdmin: true
                })
            }

            window.globalVars.server.api({
                method: "get",
                url: "/api/user/" + id,
                data: {},
                then: function(res) {

                    if (Utilities.isENU(res.data.data)) {
                        ToastStore.error("Coudln't get user");
                    } else {
                        this.setState({
                            user: res.data.data
                        })
                    }

                }.bind(this),
                catch: function(e) {

                    ToastStore.error("Coudln't get user");

                }.bind(this)
            })

            window.globalVars.server.api({
                method: "get",
                url: orderAPIUrl,
                data: {},
                then: function(res) {

                    if ( (Utilities.isENU(res.data)) || (res.data.success === false) ) {
                        ToastStore.error("Coudln't get orders");
                    } else {
                        this.setState({
                            orders: res.data.data
                        })
                    }

                }.bind(this),
                catch: function(e) {

                    ToastStore.error("Coudln't get orders");

                }.bind(this)
            })

        }.bind(this), 200)

    }

    makeAddressDefault = (id) => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/user/address/make-default/" + this.state.user._id + "/" + id,
            data: {},
            then: function(res) {

                if (res.data.success === true) {
                    this.getUser();
                } else {
                    ToastStore.error("Couldn't make default");
                }

            }.bind(this),
            catch: function(e) {

                ToastStore.error("Couldn't make default");

            }.bind(this)
        })

    }

    deleteAddress = (id) => {

        window.globalVars.server.api({
            method: "delete",
            url: "/api/user/address/" + this.state.user._id + "/" + id,
            data: {},
            then: function(res) {

                if (res.data.success === true) {
                    //ToastStore.success("Coudln't get address");
                    this.getUser();
                } else {
                    ToastStore.error("Couldn't delete address");
                }

            }.bind(this),
            catch: function(e) {

                ToastStore.error("Coudln't delete address");

            }.bind(this)
        })

    }

    render() {

        return (
            <div className="profile-container">

                <MetaTags>
                    <meta name="robots" content="noindex" />
                    <meta name="googlebot" content="noindex" />
                </MetaTags>

                <div className="main-container">
                    <div className="profile">
                        <h1>{ (!this.state.isAdmin) ? "My Account" : "Customer Details" }</h1>
                        <section>
                            <h2>
                                Details
                                <Link to={"/profile/edit" + (this.state.isAdmin ? "/" + this.state.user._id : "")}>Edit</Link>
                            </h2>
                            <hr />
                            <div>
                                <div className="entry">
                                    <label>First Name</label>
                                    <p>{ (this.state.user.firstName || "-") }</p>
                                </div>
                                <div className="entry">
                                    <label>Last Name</label>
                                    <p>{ (this.state.user.lastName || "-") }</p>
                                </div>
                                <div className="entry">
                                    <label>Email</label>
                                    <p>{ (this.state.user.email || "-") }</p>
                                </div>
                                { (!this.state.isAdmin) && <div className="entry">
                                    <label>Password</label>
                                    <p>
                                        <Link to="/profile/password/edit">Change Password</Link>
                                    </p>
                                </div> }
                                <div className="entry">
                                    <label>Phone</label>
                                    <p>{ (this.state.user.tel || "-") }</p>
                                </div>
                            </div>
                        </section>
                        <section>
                            <h2>Address</h2>
                            <hr />
                            <div>
                                { (Utilities.isENU(this.state.user.addresses)) ?
                                        <div className="entry address immutable">
                                            <label>Billing Address</label>
                                            <div>
                                                <p>-</p>
                                                <p>-</p>
                                            </div>
                                        </div>
                                    :
                                        this.state.user.addresses.filter(item => item.type === "billing").map(item => {
                                            return (
                                                <div key={item._id} className="entry address immutable">
                                                    <label>Billing Address</label>
                                                    <div>
                                                        { (window.region === "SG") && <p>{item.address1}</p> }
                                                        { (window.region === "SG") && <p>{item.address2}</p> }
                                                        { (window.region === "SG") && <p>{item.address3}</p> }
                                                        { (window.region === "MY") && <p>{item.address1My}</p> }
                                                        { (window.region === "MY") && <p>{item.address2My}</p> }
                                                        { (window.region === "MY") && <p>{item.cityMy}</p> }
                                                        { (window.region === "MY") && <p>{item.postalCodeMy}</p> }
                                                        { (window.region === "MY") && <p>{item.stateMy}</p> }
                                                    </div>
                                                    { (!this.state.isAdmin) &&
                                                        <div className="options one">
                                                            <Link to={"/profile/address/edit/" + item.id}>Edit</Link>
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })
                                }
                                { (Utilities.isENU(this.state.user.addresses)) ?
                                        <div className="entry address immutable">
                                            <label>Delivery Address</label>
                                            <div>
                                                <p>-</p>
                                                <p>-</p>
                                                <p>-</p>
                                            </div>
                                            { (!this.state.isAdmin) &&
                                                <div className="options">
                                                    <Link to="#">Edit</Link>
                                                </div>
                                            }
                                        </div>
                                    :
                                        this.state.user.addresses
                                            .filter(item => item.type === "delivery")
                                            .sort(item => {
                                                if (item.default) {
                                                    return -1;
                                                } else {
                                                    return 1;
                                                }
                                            })
                                            .map((item, i) => {
                                            return (
                                                <div key={item._id} className={"entry address " + ( (i === 0) ? "immutable" : "" ) }>
                                                    <label>{(i === 0) ? "Delivery Address" : ""}</label>
                                                    <div>
                                                        { (window.region === "SG") && <p>{item.address1}</p> }
                                                        { (window.region === "SG") && <p>{item.address2}</p> }
                                                        { (window.region === "SG") && <p>{item.address3}</p> }
                                                        { (window.region === "MY") && <p>{item.address1My}</p> }
                                                        { (window.region === "MY") && <p>{item.address2My}</p> }
                                                        { (window.region === "MY") && <p>{item.cityMy}</p> }
                                                        { (window.region === "MY") && <p>{item.postalCodeMy}</p> }
                                                        { (window.region === "MY") && <p>{item.stateMy}</p> }
                                                    </div>
                                                    { (!this.state.isAdmin) &&
                                                        <div className="options">
                                                            <Link to={"/profile/address/edit/" + item.id}>Edit</Link>
                                                            { (item.default === false) ? <button onClick={() => { if (window.confirm('Are you sure you want to delete this address?')) this.deleteAddress(item.id) } }>Delete</button> : null }
                                                            { (item.default === false) ? <button onClick={() => {this.makeAddressDefault(item.id)}}>Make default</button> : null }
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })
                                }
                                { (!this.state.isAdmin) &&
                                    <div className="entry address">
                                        <Link to="/profile/address/edit/new">Add new address</Link>
                                    </div>
                                }
                            </div>
                        </section>
                        <section>
                            <h2>Previous Orders</h2>
                            <hr />
                            {
                                (Utilities.isENU(this.state.orders)) &&
                                    <div>
                                        <Link to="#" className="entry order">
                                            <label className="no-underline">Loading</label>
                                            <p></p>
                                        </Link>
                                    </div>
                            }
                            {
                                (!Utilities.isENU(this.state.orders)) && (this.state.orders.length === 0) &&
                                    <div>
                                        <Link to="#" className="entry order">
                                            <label className="no-underline">No orders</label>
                                            <p></p>
                                        </Link>
                                    </div>
                            }
                            {
                                (!Utilities.isENU(this.state.orders)) && (this.state.orders.length > 0) &&
                                    <div>
                                        {
                                            this.state.orders.map(item => {
                                                return (
                                                    <Link key={item._id} to={"/order/" + item._id} className="entry order">
                                                        <label>{item._id}</label>
                                                        <p>{Utilities.formatDate(item.createdAt, "DD/MM/YYYY")}</p>
                                                    </Link>
                                                )
                                            })
                                        }
                                    </div>
                            }
                        </section>
                    </div>
                </div>
                <ToastContainer store={ToastStore}/>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/Profile.js